import { render, staticRenderFns } from "./DonateCustomAmount.vue?vue&type=template&id=b64ce4cc&"
import script from "./DonateCustomAmount.vue?vue&type=script&lang=js&"
export * from "./DonateCustomAmount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports